/**
 * @fileoverview Daily review and daily notes route definitions.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const DailyNotesListPage = lazy(() => import('../../features/daily-review/pages/DailyNotesListPage'));
const DailyReviewPage = lazy(() => import('../../features/daily-review/pages/DailyReviewPage'));

export const dailyReviewRoutes: RouteObject[] = createRoutes([
  { path: 'daily-notes', Component: DailyNotesListPage },
  { path: 'daily-notes/new', Component: DailyReviewPage },
  { path: 'daily-review', Component: DailyReviewPage },
  { path: 'daily-review/:noteId', Component: DailyReviewPage },
]);
